module.exports = __webpack_public_path__ + "static/media/colorad-symphony-highnote-series.b7def818.png";